import { render, staticRenderFns } from "./ViewLicenseKind.vue?vue&type=template&id=36f43854&scoped=true"
import script from "./ViewLicenseKind.vue?vue&type=script&lang=js"
export * from "./ViewLicenseKind.vue?vue&type=script&lang=js"
import style0 from "./ViewLicenseKind.vue?vue&type=style&index=0&id=36f43854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f43854",
  null
  
)

export default component.exports